export const ROUTES = {
  Home: () => "/",
  App: () => "/app",

  // Session routes
  Session: (sessionId) => `/app/session/${sessionId}`,
  SessionImages: (sessionId) => `/app/session/${sessionId}/images`,
  SessionColours: (sessionId) => `/app/session/${sessionId}/colours`,
  SessionAudio: (sessionId) => `/app/session/${sessionId}/audio`,
  SessionPreview: (sessionId) => `/app/session/${sessionId}/preview`,
  SessionExport: (sessionId) => `/app/session/${sessionId}/export`,

  // Builder routes
  Images: () => "/images",
  Colours: () => "/colours",
  Audio: () => "/audio",
  Preview: () => "/preview",
  Export: () => "/export",

  Settings: () => "/dashboard/settings",

  // Authentication routes
  Login: () => "/auth/login",
  SignUp: () => "/auth/signup",
  VerifyEmail: () => "/auth/verify-email",
  ForgotPassword: () => "/auth/forgot-password",
  ResetPassword: () => "/auth/reset-password",
  Logout: () => "/logout",
};
